
export default {
  'm':{
    'collect_cards_slogan':'Coletar cartões para ganhar milhões de diamantes',
    'participate_event':'Gostaria de participar',
    'event_rule_title':'Regras de evento',
    'event_rule_desc':'Para cada 300 diamantes recarregados durante o evento, você poderá sacar uma vez, e com certeza receberá um Cartão aleatório, e poderá resgatar um Cartão Rei coletando cinco Cartões diferentes. Aqueles que têm um Cartão Rei dividirão o prêmio de acordo com o número dos Cartões Rei que tiverem. Os prêmios serão concedidos automaticamente no final do evento.',
    'draws_diamonds_num':'Número de diamantes recarregados',
    'available_draws':'Número de sorteios restantes',
    'sel_card':'Clique para selecionar um Cartão',
    'gift_id':'ID do receptor',
    'synthesis':'Sintetizar',
    'gongxi_tip':'ID: {msg_ss}**** sintetizou o Cartão Rei',
    'divide_countdown':'Para contagem regressiva para dividir o prêmio dos Cartões Rei',
    'congra_baron':'Parabéns pelo seu Cartão Barão!',
    'congra_viscount':'Parabéns pelo seu Cartão Visconde!',
    'congra_earl':'Parabéns pelo seu Cartão Earl!',
    'congra_marquis':'Parabéns pelo seu Cartão Marquês!',
    'congra_duke':'Parabéns pelo seu Cartão Duque!',
    'congra_king':'Parabéns pelo seu valioso Cartão Rei!',
    'reward_king':'Recompensa do Cartão Rei',
    'click_send_friend':'Você pode clicar no cartão para enviá-lo a um amigo',
    'reward_tip':'A recompensa final é a contribuição de todos os usuários que participam do evento',
    'participated':'Participou',
    'event_finish':'O evento está encerrado',
    'recipient_not':'O receptor não existe',
    'baoming_canjia':'Por favor, registre-se primeiro',
    'card_not_enough':'Número insuficiente de Cartões',
    'not_draws':'Você ficou sem sorteios',
    'sel_a_card':'Por favor, selecione o Cartão a ser enviado',
    'send_success':'Sucesso de Presente',
    'not_this_card':'Você ainda não tem este Cartão',
    'reward_delay_notice':'É tão movimentado, sua recompensa chegará mais tarde',
    'friend_send_nan':'{msg_ss} lhe enviou um Cartão Barão',
    'friend_send_zi':'{msg_ss} lhe enviou um Cartão Visconde',
    'friend_send_bo':'{msg_ss} lhe enviou um Cartão Earl',
    'friend_send_hou':'{msg_ss} lhe enviou um Cartão Marquês',
    'friend_send_gong':'{msg_ss} lhe enviou um Cartão Duque',
  },
}



// WEBPACK FOOTER //
// ./src/i18n/lang/pt.js